import { loadFragments } from './fragmentLoader'

document.addEventListener("DOMContentLoaded", () => {
    console.log("DOMContentLoaded");
    loadFragments();
}, { once: true });
